import React from 'react';
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import InvoicesProvider from '../../store/invoices/invoicesProvider';
import InvoiceList from '../../containers/invoices/InvoiceList';

function InvoicesPage() {  

  const { appState: { user, userAccount }} = useApp();

  if (!user) return '';
  if (!user._id) return '';
  
  return (
    <InvoicesProvider>
      <PageWrapper navbar title={userAccount.isAdmin ? 'Invoice Manager' : 'My Invoices'}>
        <InvoiceList />
      </PageWrapper>
    </InvoicesProvider>
  )
}

export default InvoicesPage;
